import { useMemo, useContext } from 'react';

import { useWebItemLocation, SYSTEM_HEADER_LEFT } from '@confluence/web-item-location';
import { useIsCompanyHubEnabled } from '@confluence/company-hub-utils/entry-points/useIsCompanyHubEnabled';
import { SPAViewContext } from '@confluence/spa-view-context';
import { useViewUserProfile } from '@confluence/global-operations';

import { PEOPLE_DIRECTORY_KEY, SPACE_DIRECTORY_KEY } from '../../useMenuItems';

export const useShortcutVisibilityOverrides = () => {
	const { loading: webItemsLoading, webItems } = useWebItemLocation({
		location: SYSTEM_HEADER_LEFT,
		allowedWebItems: [SPACE_DIRECTORY_KEY, PEOPLE_DIRECTORY_KEY],
	});
	const { isCompanyHubEntryPointEnabled } = useIsCompanyHubEnabled();
	const { frontCoverState, loading } = useContext(SPAViewContext);
	const { canViewUserProfile: hasViewUserProfilePermission } = useViewUserProfile();

	const isPeopleVisible =
		!webItemsLoading &&
		(hasViewUserProfilePermission ||
			!!webItems.find((item) => item.completeKey === PEOPLE_DIRECTORY_KEY));
	const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;

	return useMemo(
		() => ({
			isPeopleVisible,
			isCompanyHubVisible,
		}),
		[isCompanyHubVisible, isPeopleVisible],
	);
};
